module.exports = __webpack_public_path__ + "static/media/podcast.f3a0dae8.png";